/**
 * Roving-tabindex arrow navigation (WAI-ARIA tablist / toolbar pattern): where focus goes next for a
 * key press over `len` stops, wrapping at both ends. Shared by every tab strip in the SPA so an a11y
 * fix (RTL, PageUp/Down) lands once.
 *
 * @param {string} key  `KeyboardEvent.key`
 * @param {number} idx  the focused stop
 * @param {number} len  number of stops
 * @returns {number | null} the next index, or null when the key is not a navigation key
 */
export function nextRovingIndex(key, idx, len) {
  if (!(len > 0)) return null;
  switch (key) {
    case 'ArrowRight': return (idx + 1) % len;
    case 'ArrowLeft': return (idx - 1 + len) % len;
    case 'Home': return 0;
    case 'End': return len - 1;
    default: return null;
  }
}
